/*
nav_deposit/view_nav
create and handle all dom-nodes for the depositflow navigation: skip, close, back, title.

the selectors are set in the global navigation and can be:
// root: '#js-deposit-flow',
// btn_back: '#js-deposit-back-btn',
// btn_close: '#js-deposit-close-btn',
// btn_skip: '#js-deposit-skip-btn',
// header_title: '#js-deposit-header-title',
// nextbtnwrap: '.js-next-btn-wrap'
*/
import core from '../../common/lib/core.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';
import utils from './../../../utils.js';

const callbacks = {};
const selectors = {};
let elements = null;
let textkeysObj = {};
const classnameOpen = 'deposit--open';
let listenersAdded = false;
let srollHandlerAdded = false;

/* set title of wrapping page */
function updateContent(elm, text) {
	const node = elm;
	if (node) {
		node.innerHTML = text;
	} else {
		console.warn('view_nav:29:updateContent: no element provided', elm);
	}
	return node;
}

function showParentWrap() {
	if (!core.hasClass(elements.wrap, classnameOpen)) {
		core.addClass(elements.wrap, classnameOpen);
	}
}

function hideParentWrap() {
	if (core.hasClass(elements.wrap, classnameOpen)) {
		core.removeClass(elements.wrap, classnameOpen);
	}
}

function backListener() {
	if (callbacks.back) {
		callbacks.back();
	}
}

function closeListener() {
	if (callbacks.close) {
		callbacks.close();
	}
}

function skipListener() {
	if (callbacks.skip) {
		callbacks.skip();
	}
}

function addListeners() {
	if (!listenersAdded) {
		if (elements.back) {
			elements.back.addEventListener('click', backListener);
		}
		if (elements.close) {
			elements.close.addEventListener('click', closeListener);
		}
		if (elements.skip) {
			elements.skip.addEventListener('click', skipListener);
		}
		listenersAdded = true;
	}
}

function removeListeners() {
	if (listenersAdded && elements) {
		if (elements.back) {
			core.removeListener(elements.back, 'click', backListener);
		}
		if (elements.close) {
			core.removeListener(elements.close, 'click', closeListener);
		}
		if (elements.skip) {
			core.removeListener(elements.skip, 'click', skipListener);
		}
		listenersAdded = false;
	}
}

function hideNavElm(elm) {
	core.removeClass(elm, 'u-show');
	core.addClass(elm, 'u-hide');
}

function showNavElm(elm) {
	core.removeClass(elm, 'u-hide');
	core.addClass(elm, 'u-show');
}

function setUpScrollHandlers() {
	// add scroll listener to deposit steps, it will add a class to the header to avoid text overlapping
	// TODO; this eventhandler should be possible to remove, and included in the 'add-/removeListeners' above
	if (!srollHandlerAdded && elements) {
		const pageHead = elements.wrap.querySelector('.page-head');
		const changeHeaderWhenScroll = utils.debounce((e) => {
			if (e.target.scrollTop > 25) {
				core.addClass(pageHead, 'page-head--opac');
			} else {
				core.removeClass(pageHead, 'page-head--opac');
			}
		}, 100);
		elements.wrap.addEventListener('scroll', changeHeaderWhenScroll, true);
		srollHandlerAdded = true;
	}
}

export default {
	init(conf) {
		const textkeyIndexTitle = ((conf && conf.textkeys) && conf.textkeys.title);
		let titleText = 'titletext';
		/* the key of the selector is the same as the name of the key in the elements:
		selectors.wrap = '#js-foo' elements.wrap = [a dom node]
		*/
		selectors.wrap = conf.wrap.selector;
		selectors.back = conf.back.selector;
		selectors.close = conf.close.selector;
		selectors.skip = conf.skip.selector;
		selectors.title = conf.title.selector;
		selectors.textkeys = conf.textkeys.selector;
		/* update navigation according to conf */
		elements = core.selectElements(selectors, 'view_nav:init:120');
		textkeysObj = viewTextkeys.depositflow();
		titleText = ((textkeyIndexTitle && textkeysObj[textkeyIndexTitle]) || '');

		function showHideNav(cfig, keys) {
			/* this function assumes that selectors-keys are identical to elements-keys
			If either a url or a callback function is parsed the nav-element will be shown. */
			keys.forEach((key) => {
				if (cfig[key].url || cfig[key].cb) {
					showNavElm(elements[key]);
				} else {
					hideNavElm(elements[key]);
				}
			});
		}

		showHideNav(conf, ['back', 'close', 'skip']);
		showParentWrap();

		/* set titletext of page */
		updateContent(elements.title, titleText);

		/* parse callbacks and urls*/
		function parseCallbacks(cfig, keys) {
			keys.forEach((key) => {
				if (cfig[key].cb) {
					callbacks[key] = cfig[key].cb;
				}
			});
		}

		parseCallbacks(conf, ['back', 'close', 'skip']);

		/* if urls are provided then set them to the nav-buttons (only valid if the nav-button is an anchor-element) */
		function replaceUrls(cfig, keys) {
			keys.forEach((key) => {
				if (cfig[key].url && elements[key] && elements[key].setAttribute) {
					elements[key].setAttribute('href', cfig[key].url);
					if (!cfig[key].isPush) {
						elements[key].setAttribute('refresh', '');
					}
				}
			});
		}

		replaceUrls(conf, ['back', 'close', 'skip']);
		addListeners();
		setUpScrollHandlers();
	},
	close() {
		removeListeners();
		hideParentWrap();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/navdeposit/lib/view-nav.js